import useSWR from "swr";
import linkedProductCategoryService from "@/services/linked-product-category.service";
import { ILinkedProductCategory } from "@/interfaces/linked-product-category.interface";

type Props = {
  productId: number | null;
};

export type UseGetLinkedCategoriesReturn = {
  data: ILinkedProductCategory[] | undefined;
  isLoading: boolean;
  error: Error | undefined;
};

const useGetLinkedCategories = ({ productId }: Props): UseGetLinkedCategoriesReturn => {
  const { data, error, isLoading } = useSWR(
    productId ? `linked-categories-${productId}` : null,
    () => productId ? linkedProductCategoryService.getByProductId(productId) : null
  );

  return {
    data: data || undefined,
    isLoading,
    error,
  };
};

export default useGetLinkedCategories;
